import {
  CLEAR_BUDGET,

  DELETE_BUDGET,
  DELETE_BUDGET_ERROR,
  DELETE_BUDGET_SUCCESS,

  GET_BUDGET,
  GET_BUDGET_ERROR,
  GET_BUDGET_SUCCESS,

  // GET_BUDGETS,
  // GET_BUDGETS_ERROR,
  // GET_BUDGETS_SUCCESS,

  SAVE_BUDGET,
  SAVE_BUDGET_ERROR,
  SAVE_BUDGET_SUCCESS,

  DOWNLOAD_BUDGET,
  DOWNLOAD_BUDGET_ERROR,
  DOWNLOAD_BUDGET_SUCCESS,

} from './constants';

export default {
  [CLEAR_BUDGET](state) {
    state.budget = {};
  },

  [DELETE_BUDGET](state) {
    state.error = false;
    state.loading = true;
  },
  [DELETE_BUDGET_ERROR](state, payload) {
    state.error = payload;
    state.loading = false;
  },
  [DELETE_BUDGET_SUCCESS](state) {
    state.account = false;
    state.loading = false;
  },

  [GET_BUDGET](state) {
    state.error = false;
    state.loading = true;
    state.success = false;
  },
  [GET_BUDGET_ERROR](state, payload) {
    state.error = payload;
    state.loading = false;
  },
  [GET_BUDGET_SUCCESS](state, payload) {
    state.budgets = payload;
    state.loading = false;
    state.success = true;
  },

  [SAVE_BUDGET](state) {
    state.error = false;
    state.formLoading = true;
  },
  [SAVE_BUDGET_ERROR](state, payload) {
    state.error = payload;
    state.formLoading = false;
  },
  [SAVE_BUDGET_SUCCESS](state) {
    state.formLoading = false;
  },

  [DOWNLOAD_BUDGET](state) {
    state.downloadLink = '';
    state.success = false;
    state.error = false;
    state.exportLoading = true;
  },
  [DOWNLOAD_BUDGET_ERROR](state, payload) {
    state.error = payload;
    state.exportLoading = false;
  },
  [DOWNLOAD_BUDGET_SUCCESS](state, payload) {
    state.downloadLink = payload;
    state.exportLoading = false;
    state.success = true;
  },

  // single object item mutation
  updateItem(state, payload) {
    state.account[payload.item] = payload.value;
  },
};



// WEBPACK FOOTER //
// ./src/components/Syndicates/Syndicate/Budget/mutations.js